<template>
    <div class="side-navigation">
        <div :class="{'wrapper-side-logo': isJACareerEntrepreApp}">
            <div class="be-logo"></div>
            <div v-if="isJACareerEntrepreApp" class="side-app-name">
                <span class="side-app-name__title">
                    JA Future by Design: Entrepreneurship
                </span>
            </div>
        </div>
        <b-nav vertical :class="{'isCareerEntrep': isJACareerEntrepreApp}" class="nav-side-navigation mb-5">
            <b-nav-text :class="{'disabled': lastStep<2, 'current': currentStep===2, 'isCareerEntrep': isJAEntrepreApp}">Deep Customer Empathy</b-nav-text>
            <b-nav-item :class="{'disabled': lastStep<3, 'current': currentStep===3}" :disabled="(lastStep<3)"
                        :to="{ name: 'be_deep_customer_empathy_3', params: { index } }">
                        Develop Your Self-Empathy
            </b-nav-item>
            <b-nav-item :class="{'disabled': lastStep<4, 'current': currentStep===4}" :disabled="(lastStep<4)"
                        :to="{ name: 'be_deep_customer_empathy_4', params: { index } }">
                        Instructions to go do the Customer Empathy work and then come back
            </b-nav-item>
            <b-nav-item :class="{'disabled': lastStep<5, 'current': currentStep===5}" :disabled="(lastStep<5)"
                        :to="{ name: 'be_deep_customer_empathy_5', params: { index } }">
                        What did you learn from your customer empathy work?
            </b-nav-item>
            <b-nav-item :class="{'disabled': lastStep<6, 'current': currentStep===6}" :disabled="(lastStep<6)"
                        :to="{ name: 'be_deep_customer_empathy_6', params: { index } }">
                        What did you learn from your customer empathy work?
            </b-nav-item>
            <b-nav-item :class="{'disabled': lastStep<7, 'current': currentStep===7}" :disabled="(lastStep<7)"
                        :to="{ name: 'be_deep_customer_empathy_7', params: { index } }">
                        Write your Customer Problem Statement
            </b-nav-item>
            <b-nav-item :class="{'disabled': lastStep<8, 'current': currentStep===8}" :disabled="(lastStep<8)"
                        :to="{ name: 'be_deep_customer_empathy_8', params: { index } }">
                        Write your Customer Problem Statement
            </b-nav-item>
            <b-nav-item :class="{'disabled': lastStep<9, 'current': currentStep===9}" :disabled="(lastStep<9)"
                        :to="{ name: 'be_deep_customer_empathy_9', params: { index } }">
                        Write the Ideal State
            </b-nav-item>
            <b-nav-text :class="{'disabled' : lastStep<10, 'current': currentStep===10}">Go Broad to go narrow</b-nav-text>

            <b-nav-item :class="{'disabled': lastStep<11, 'current': currentStep===11}" :disabled="(lastStep<11)"
                        :to="{ name: 'be_go_broad_to_go_narrow_11', params: { index } }">
                        Brainstorming
            </b-nav-item>
            <b-nav-item :class="{'disabled': lastStep<12, 'current': currentStep===12}" :disabled="(lastStep<12)"
                        :to="{ name: 'be_go_broad_to_go_narrow_12', params: { index } }">
                        Go Broad: Brainstorm session summary
            </b-nav-item>
            <b-nav-item :class="{'disabled': lastStep<13, 'current': currentStep===13}" :disabled="(lastStep<13)"
                        :to="{ name: 'be_go_broad_to_go_narrow_13', params: { index } }">
                        Going Even More Narrow
            </b-nav-item>
            <b-nav-item :class="{'disabled': lastStep<14, 'current': currentStep===14}" :disabled="(lastStep<14)"
                        :to="{ name: 'be_go_broad_to_go_narrow_14', params: { index } }">
                        Go Narrow: What were the top ideas?
            </b-nav-item>
            <b-nav-item :class="{'disabled': lastStep<15, 'current': currentStep===15}" :disabled="(lastStep<15)"
                        :to="{ name: 'be_go_broad_to_go_narrow_15', params: { index } }">
                       Go Narrow: What were the top ideas?
            </b-nav-item>
            <b-nav-item :class="{'disabled': lastStep<16, 'current': currentStep===16}" :disabled="(lastStep<16)"
                        :to="{ name: 'be_go_broad_to_go_narrow_16', params: { index } }">
                        Go Narrow: Sketch and upload the
                first idea you'll test
            </b-nav-item>
            <b-nav-text :class="{'disabled' : lastStep<17,  'current': currentStep===17}">Rapid Experiments With Customers</b-nav-text>

            <b-nav-item :class="{'disabled': lastStep<18, 'current': currentStep===18}" :disabled="(lastStep<18)"
                        :to="{ name: 'be_rapid_experiments_with_customers_18', params: { index } }">
                        What are your Leap of Faith Assumptions
            </b-nav-item>
            <b-nav-item :class="{'disabled': lastStep<19, 'current': currentStep===19}" :disabled="(lastStep<19)"
                        :to="{ name: 'be_rapid_experiments_with_customers_19', params: { index } }">
                        Types of Experiments
            </b-nav-item>
            <b-nav-item :class="{'disabled': lastStep<20, 'current': currentStep===20}" :disabled="(lastStep<20)"
                        :to="{ name: 'be_rapid_experiments_with_customers_20', params: { index } }">
                        Experiment Plan
            </b-nav-item>
            <b-nav-item :class="{'disabled': lastStep<21, 'current': currentStep===21}" :disabled="(lastStep<21)"
                        :to="{ name: 'be_rapid_experiments_with_customers_21', params: { index } }">
                        Instructions to go do the test and then come back
            </b-nav-item>
            <b-nav-item :class="{'disabled': lastStep<22, 'current': currentStep===22}" :disabled="(lastStep<22)"
                        :to="{ name: 'be_rapid_experiments_with_customers_22', params: { index } }">
                        Test Results
            </b-nav-item>
            <b-nav-item :class="{'disabled': lastStep<23, 'current': currentStep===23}" :disabled="(lastStep<23)"
                        :to="{ name: 'be_rapid_experiments_with_customers_23', params: { index } }">
                        Next steps
            </b-nav-item>

        </b-nav>
    </div>
</template>

<script>

    import navigation from '../../../core/Mixins/navigation'

    export default {
        name: "BENavigation",
        props: ['label'],
        mixins: [navigation],
    }
</script>

<style lang="stylus" scoped>
    @import "../../D4D/Styles/d4d_styles.styl"

    .be-logo
        content url("../../Home/Images/ja-be-entreprenurial.jpg")
        background-repeat no-repeat
        height auto
        width 100%
        margin 0 auto
        background-position-y -120px
        border-radius 20px 20px 20px 20px
        box-shadow(0px 4px 5px 0px #BDD5E580)

    .wrapper-side-logo
        padding-top 20px
        width 100%
        height auto
        .be-logo
            border-radius 20px 20px 0 0

    .side-app-name
        background-color color-green-light
        height 75px
        display flex
        align-items center
        justify-content center
        border-radius 0 0 20px 20px
        box-shadow(0px 4px 5px 0px color-19)
        padding 0 15px

        &__title
            font font-poppins-semibold
            font-size 16px
            color color-blank

</style>
